<template>
    <article class="row">
        <blog-search
            :searchString="filterBy.searchString"
            :handleSearch="handleSearch"
        />
        <blog-filter
            :category="filterBy.category"
            :visibility="filterBy.visibility"
            :categoryTypes="categoryTypes"
            :visibilityTypes="visibilityTypes"
            :handleCategory="handleCategory"
            :handleVisibility="handleVisibility"
            :loading="loading"
        />
        <div class="ui row stackable" v-if="!loading && blogs.length == 0">
			<div class="sixteen wide column">
				<p class="centered">Trenutno ni novic.</p>
			</div>
		</div>
        <div class="col col-12" v-else>
            <div class="twelve wide column" v-if="loading">
				<div class="ui segment">
					<div class="ui active centered inline loader"></div>
				</div>
			</div>
            <div v-if="!loading" >
                <div class="news-item">
                    <div class="col offset-2 col-8 news-card">
                        <iframe
                            id="predstavitveni-video"
                            :class="filterBy.searchString != '' || filterBy.visibility != '' || filterBy.category != '' ? 'hidden' : ''"
                            src="https://s3-eu-west-1.amazonaws.com/rokus-video-transcode/player/index.html?video=marketing/izziblog_prva_pomo_za_star_e/stream"
                            frameborder="0"
                            allowfullscreen="allowfullscreen"
                            >
                        </iframe>
                        <blog-filter-legend
                            :visibility="filterBy.visibility"
                            :handleVisibility="handleVisibility"
                        />
                    </div>
                </div>
                <div
                    v-for="(blogsItem, idx) in filteredBlogs"
                    :key="blogsItem.unique_id"
                    class="news-item"
                    :class="{'hidden': idx > nrCards}"
                    v-waypoint="{
                        active: true,
                        callback: onWaypoint,
                        options: intersectionOptions
                    }"
                    :data-idx="idx"
                    >
                    <div class="col offset-1 col-10 offset-lg-2 col-lg-8 news-card">
                        <a :href="route('warehouse.blogs.single', blogsItem.permalink)">
                            <div class="razred-image" v-if="blogsItem.hero_image_url">
                                <img :src="idx < nrCards ? blogsItem.hero_image_url : ''" alt="naslovna slika">
                                <div class="visibility-image-container">
                                    <img src="/images/blog/ucenci.png" v-if="visibilityImageType(blogsItem.visibility, 'student')" title="za učence">
                                    <img src="/images/blog/starsi.png" v-if="visibilityImageType(blogsItem.visibility, 'parent')" title="za starše">
                                    <img src="/images/blog/ucitelji.png" v-if="visibilityImageType(blogsItem.visibility, 'teacher')" title="za učitelje">
                                </div>
                            </div>
                            <div class="razred-no-image" v-else></div>
                        </a>
                        <div class="txt-container">
                            <div class="content">
                                <div class="header">
                                    <a :href="route('warehouse.blogs.single', blogsItem.permalink)" target="_blank">{{blogsItem.title}}</a>
                                </div>
                                <div class="description" v-html="blogsItem.excerpt" :data-brez="blogsItem.excerpt"></div>
                            </div>
                            <div class="pink-btn-container">
                                <a target="_blank" class="izzi-button pink" :href="route('warehouse.blogs.single', blogsItem.permalink)">Preberi več</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import BlogSearch from "./BlogSearch.vue";
import BlogFilter from "./BlogFilter.vue";
import queryString from 'query-string'
import BlogFilterLegend from './BlogFilterLegend.vue';

export default {
    components: {
        BlogSearch,
        BlogFilter,
        BlogFilterLegend
	},
    data() {
        return {
            intersectionOptions: {
                root: null,
                rootMargin: '0px 0px 0px 0px',
                threshold: [0.25, 0.75] // [0.25, 0.75] if you want a 25% offset!
            },
            nrCards: 10,
            activeFilter: null,
            loading: true,
            subjects: undefined,
			blogs: [],
            filterBy: {
                searchString: "",
                visibility: "",
                category: ""
            },
            // ENUM polje v db (visibility)
            visibilityTypes: {
                "student": "Za učence",
                "teacher": "Za učitelje",
                "parent": "Za starše",
                "all": "Za vse",

                "Za učence": "student",
                "Za starše": "parent",
                "Za učitelje": "teacher",
                "Za vse": "all",
            },
            // ENUM polje v db (type)
            categoryTypes: {
                "post": "Članki",
                "podcast": "Podkasti",
                "video": "Videi",
                "webinar": "Webinarji",
                "all": "Vse vsebine",

                "Članki":"post",
                "Podkasti":"podcast",
                "Videi": "video",
                "Webinarji": "webinar",
                "Vse vsebine": "all"
            }
        }
    },
    mounted() {
        this.loadBlogs();
    },
    methods: {
        loadBlogs() {
            axios.get(this.route('warehouse.blogs.all')).then(({data}) => {
                this.loading = false
                this.subjects = data.subjects
                this.blogs = data.news.filter(item => !item.hidden);

				this.setupInitalFilter();
            })
        },
		setupInitalFilter() {
			if (location.hash != '') {
				let filterValues = Object.keys(queryString.parse(location.hash))
				filterValues.forEach(filter => {
                    const visibiltyFilter = this.visibilityTypes[filter];
                    const categoryFilter = this.categoryTypes[filter];
                   if (filter != 'all' && visibiltyFilter != null) {
                       this.handleVisibility(visibiltyFilter, visibiltyFilter);
                   } else if (filter != 'all' && categoryFilter != null) {
                        this.handleCategory(categoryFilter, categoryFilter);
                   }
				})
			}
		},
        onWaypoint ({ el, going, direction }) {
            if (going === this.$waypointMap.GOING_IN) {
                const cardId = +el.dataset.idx + 1;
                this.nrCards = cardId > this.nrCards ? this.nrCards + 10 : this.nrCards;
            }
        },
        resetWaypointsIndex() {
            this.nrCards = 10;
        },
        visibilityImageType(visibility, type) {
            if (visibility === 'all') {
                return true;
            }
            const visibilityArr = visibility.split('-');
            return visibilityArr.indexOf(type) > -1;
        },
        handleSearch(filterString) {
            this.resetWaypointsIndex();
            this.filterBy.searchString = filterString.toLowerCase();
        },
        handleCategory(category, oldCategory) {
            this.resetWaypointsIndex();
            this.filterBy.category = category;
            this.handlelocationHash("category", category, oldCategory);
        },
        handleVisibility(visibility, oldVisibility) {
            this.resetWaypointsIndex();
            this.filterBy.visibility = visibility;
            this.handlelocationHash("visibility", visibility, oldVisibility);
        },
        handlelocationHash(type, value, previousValue) {

            let filteredValues = Object.keys(queryString.parse(location.hash));
            const typeArr = type + "Types";
            const normalizedValue = this[typeArr][value];
            const previousNormalizedValue = this[typeArr][previousValue];
            // zbrišemo morebiten star hash za kategorijo, če je bil izbran visibility = "all", t.j. brez filtracije
            if (normalizedValue === 'all') {
                const index = filteredValues.indexOf(previousNormalizedValue);
                index > -1 && filteredValues.splice(index, 1);
            // odstranimo morebitni prejšnji in dodamo nov hash
            } else if (normalizedValue !== 'all') {
                const index = filteredValues.indexOf(previousNormalizedValue);
                index > -1 && filteredValues.splice(index, 1);
                filteredValues.push(this[typeArr][this.filterBy[type]]);
            }

			location.hash = '#' + filteredValues.join('&');
        },
        hasSearchString(item, searchString) {
            if (item.excerpt   && item.excerpt.toLowerCase().indexOf(searchString) > -1)   { return true; }
            if (item.title     && item.title.toLowerCase().indexOf(searchString) > -1)     { return true; }
            if (item.permalink && item.permalink.toLowerCase().indexOf(searchString) > -1) { return true; }
            return false;
        },
        hasVisibility(blog, visibilityName) {
            if (visibilityName == this.visibilityTypes["all"] || blog.visibility == this.visibilityTypes["Za vse"]) {
                return true;
            }
            const extendedVisibility = this.visibilityTypes[visibilityName].split("-");
            if (blog.visibility && extendedVisibility.indexOf(blog.visibility) > -1) { return true; }
            // še filter za "student-parent" npr.: student | parent => true in obratno

            if (blog.visibility && blog.visibility.split("-").filter(item => extendedVisibility.indexOf(item) > -1).length > 0) {
                return true;
            }
            return false;
        },
        hasCategory(blog, categoryName) {
            if (categoryName == this.categoryTypes["all"]) {
                return true;
            }
            return blog.type === this.categoryTypes[categoryName];
        }
    },
    filters: {
		date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
        }
	},
	computed: {
		filteredBlogs() {
            const filter = {};
			if (this.filterBy.searchString) {
				filter.searchString = this.filterBy.searchString;
			}
			if (this.filterBy.visibility) {
				filter.visibility = this.filterBy.visibility;
			}
            if (this.filterBy.category) {
				filter.category = this.filterBy.category;
			}

            if (_.isEmpty(filter)) {
                return this.blogs;
            }

			let filteredBlogs = this.blogs.filter(item => {
                if (filter.visibility && filter.category && filter.searchString) {
                    if (this.hasVisibility(item, filter.visibility) && this.hasCategory(item, filter.category) && this.hasSearchString(item, filter.searchString)) {
                        return true;
                    }
                    return false;
                }
                if (filter.visibility && filter.searchString) {
                    if (this.hasVisibility(item, filter.visibility) && this.hasSearchString(item, filter.searchString)) {
                        return true;
                    }
                    return false;
                }
                if (filter.category && filter.searchString) {
                    if (this.hasCategory(item, filter.category) && this.hasSearchString(item, filter.searchString)) {
                        return true;
                    }
                    return false;
                }
                if (filter.visibility && filter.category) {
                    if (this.hasVisibility(item, filter.visibility) && this.hasCategory(item, filter.category)) {
                        return true;
                    }
                    return false;
                }
                if (filter.searchString) {
					if (this.hasSearchString(item, filter.searchString)) {
                        return true;
                    }
                    return false;
				}
                if (filter.visibility) {
                    if (this.hasVisibility(item, filter.visibility)) {
                        return true;
                    }
				}
                if (filter.category) {
                    if (this.hasCategory(item, filter.category)) {
                        return true;
                    }
				}
				return false
			});
			return filteredBlogs;
		}
	}
}
</script>
